// src/styles/theme.js

export const getThemeVars = (theme) => {
  return theme === "dark"
    ? {
        bg: "#0f0f1a",
        fg: "#e2e8f0",
        card: "#1e293b",
        btnBg: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        btnFg: "#ffffff",
        accent: "#a5b4fc",
        footerBg: "#0c0c1a",
        smallText: "#cbd5e1",
        subtleBg: "rgba(30, 40, 80, 0.18)",
        cardHover: "rgba(70, 90, 160, 0.14)",
      }
    : {
        bg: "#eceeff",
        fg: "#1a1a3e",
        card: "rgba(255,255,255,0.82)",
        btnBg: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        btnFg: "#ffffff",
        accent: "#4338ca",
        footerBg: "#dde0f5",
        smallText: "#3d4a6b",
        subtleBg: "rgba(220, 222, 248, 0.55)",
        cardHover: "rgba(99, 102, 241, 0.12)",
        cardBg: "rgba(235, 236, 255, 0.88)",
        glassContainerBg: "rgba(255,255,255,0.70)",
        glassContainerBorder: "1.5px solid rgba(99,102,241,0.16)",
        glassContainerShadow: "0 16px 64px rgba(99,102,241,0.13), inset 0 1px 0 rgba(255,255,255,0.95)",
      };
};

// Samsung neutral-light override — единственный источник правды для всех компонентов
export const getSamsungThemeVars = () => ({
  bg: '#f5f5f5',
  fg: '#1a1a1a',
  card: '#ffffff',
  btnBg: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  btnFg: '#ffffff',
  accent: '#4338ca',
  footerBg: '#e8e8e8',
  smallText: '#444444',
  subtleBg: 'rgba(0,0,0,0.04)',
  cardHover: 'rgba(0,0,0,0.06)',
  cardBg: 'rgba(0,0,0,0.03)',
  panelBg: 'rgba(245,245,245,0.97)',
});

export const globalAnimationStyles = `
  /* transform перезаписывает inline transform на том же элементе — анимацию вешайте на вложенный узел. */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-on-mount {
    opacity: 0;
    animation: fadeInUp 0.5s ease-out forwards;
  }

  /* Ступенчатая задержка для основных блоков */
  .animate-on-mount:nth-child(1)  { animation-delay: 0.10s; }
  .animate-on-mount:nth-child(2)  { animation-delay: 0.18s; }
  .animate-on-mount:nth-child(3)  { animation-delay: 0.26s; }
  .animate-on-mount:nth-child(4)  { animation-delay: 0.34s; }
  .animate-on-mount:nth-child(5)  { animation-delay: 0.42s; }
  .animate-on-mount:nth-child(6)  { animation-delay: 0.50s; }
  .animate-on-mount:nth-child(7)  { animation-delay: 0.58s; }
  .animate-on-mount:nth-child(8)  { animation-delay: 0.66s; }
`;